import { trackEvent } from '../../lib/analytics';
import Squiggle from './Squiggle';

const Hero = () => {
  const handleCtaClick = () => {
    trackEvent('cta_clicked', { cta_label: 'programme-hero', page: 'prepa-post-bac' });
  };

  return (
    <section className="ppb-hero" id="top">
      <div className="ppb-hero-bg" aria-hidden="true">
        <div className="ppb-hero-grid" />
        <div className="ppb-hero-glow ppb-hero-glow-1" />
        <div className="ppb-hero-glow ppb-hero-glow-2" />
      </div>

      <div className="container ppb-hero-inner">
        <div className="ppb-hero-badge ppb-reveal ppb-d1">
          <span className="ppb-hero-badge-dot" />
          Prépa Post-Bac · GS Sanaa
        </div>

        <h1 className="ppb-hero-title ppb-reveal ppb-d2">
          <span className="ppb-hero-title-line">L'excellence aujourd'hui,</span>
          <span className="ppb-hero-title-line">
            <span className="ppb-hero-title-emph">
              la réussite demain.
              <Squiggle className="ppb-hero-squiggle" />
            </span>
          </span>
        </h1>

        <p className="ppb-hero-lede ppb-reveal ppb-d3">
          Préparation aux concours des grandes écoles et facultés.
          Médecine, commerce, ingénierie — un accompagnement ciblé pour viser juste.
        </p>

        <div className="ppb-hero-cta-row ppb-reveal ppb-d4">
          <a href="#form" onClick={handleCtaClick} className="btn btn-primary btn-lg">
            Recevoir le programme
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
          <p className="ppb-hero-cta-note">Échange avec un conseiller orientation · Sans engagement</p>
        </div>
      </div>

      <svg
        className="ppb-curve"
        viewBox="0 0 1440 72"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path d="M0 36 Q360 72 720 36 T1440 36 L1440 72 L0 72 Z" fill="#ffffff" />
      </svg>
    </section>
  );
};

export default Hero;
